export default __webpack_public_path__ + "997a557b5e0ad9b1129698b92a3f9c7d.png";